import React from 'react'
import { AVAILABILITY_LABEL } from 'shared-constants'
import styled from 'styled-components'
import { CustomizationRequestFormModal } from 'components/CustomizationRequestFormModal'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
// import { environment } from 'constants/environment'
import { useScrollTo } from 'hooks'
import { COLOR_INTENT, FONT_STACK, FONT_WEIGHT, SPACE } from 'Theme'
import { formatLeadTimeString } from 'utils/formatters'

const StyledText = styled(Text)`
  cursor: pointer;
  width: fit-content;
`

const getProductAvailability = ({
  availableQuantity,
  minimumOrderQuantity,
  leadTimeInWeeks,
  enquire,
}: {
  availableQuantity: number
  minimumOrderQuantity: number
  leadTimeInWeeks?: number
  enquire?: boolean
}) => {
  if (leadTimeInWeeks) {
    return formatLeadTimeString(leadTimeInWeeks)
  }
  if (availableQuantity > 0 && availableQuantity >= minimumOrderQuantity) {
    return AVAILABILITY_LABEL.READY_TO_SHIP
  }
  return enquire === true ? null : AVAILABILITY_LABEL.OUT_OF_STOCK
}

interface VariantDescriptionProps {
  aboveTheFold?: string
  availableQuantity: number
  minimumQuantity: number
  isPriceUponRequest?: boolean
  location?: string
  detailsRef: React.RefObject<HTMLElement>
  leadTimeInWeeks?: number
  availability?: 'SOLD_OUT' | 'READY_TO_SHIP' | 'MADE_TO_ORDER' | 'ENQUIRE'
  enquire?: boolean
  hasPublishedStatus: boolean
  hasCustomization?: boolean
}

export const VariantDescription: React.FC<
  React.PWC<VariantDescriptionProps>
> = ({
  aboveTheFold,
  availableQuantity,
  minimumQuantity,
  isPriceUponRequest,
  location,
  detailsRef,
  leadTimeInWeeks,
  availability,
  enquire,
  hasPublishedStatus,
  hasCustomization = false,
}) => {
  const { scrollToRef } = useScrollTo({ withHeaderOffset: true })

  const isProductUnavailable = ['ENQUIRE', 'SOLD_OUT'].some(
    (unavailableProductAvailability) =>
      availability === unavailableProductAvailability
  )

  // const handleClickEnquire = () => {
  //   if (environment.CUSTOMER_SERVICE_FRAMEWORK === 'intercom') {
  //     window?.Intercom?.('show')
  //   } else {
  //     window?.FrontChat?.('show')
  //   }
  // }

  return (
    <Flex flexDirection="column">
      {aboveTheFold && <Text>{aboveTheFold}</Text>}
      {!isPriceUponRequest && hasPublishedStatus && (
        <Text
          color={isProductUnavailable && COLOR_INTENT.PRODUCT_UNAVAILABLE_TEXT}
        >
          {getProductAvailability({
            availableQuantity,
            minimumOrderQuantity: minimumQuantity,
            leadTimeInWeeks,
            enquire,
          })}
          {location && ` in ${location}`}
        </Text>
      )}
      {hasCustomization && (
        <Text>
          Customization: Want a different fabric, finish, or size?{' '}
          <CustomizationRequestFormModal
            trigger={
              <Text
                as="span"
                fontFamily={FONT_STACK.SANS}
                color={COLOR_INTENT.LINK.PRIMARY}
                // onClick={handleClickEnquire}
                style={{ cursor: 'pointer' }}
              >
                Our team can help
              </Text>
            }
          />
        </Text>
      )}
      <StyledText
        onClick={() => {
          scrollToRef(detailsRef)
        }}
        fontWeight={FONT_WEIGHT.MEDIUM}
        color={COLOR_INTENT.BRAND}
        mt={SPACE.PX_20}
        mb={SPACE.PX_10}
      >
        Details and shipping
      </StyledText>
    </Flex>
  )
}
